import { notification } from "antd";
import { action, makeAutoObservable, runInAction } from "mobx";
import { Api } from "../../../common/Api";
import { ArticlesStore } from "./ArticlesStore";
import moment from "moment";

const mapNodes = (nodes: any[] = []) => {
  return nodes.map((n) => {
    return {
      title: n.name,
      key: n.id,
      value: n.id,
      children: mapNodes(n.nodes),
    };
  });
};

export class ArticlePublishStore {
  store: ArticlesStore;
  showDlg = false;
  loading = false;
  saving = false;
  id?: string;
  article?;
  publish: any = {
    type: "All",
    commentType: "None",
    articleId: undefined,
    publishDate: undefined,
    onlyNotReached: false,
    regionIds: [],
    divisionIds: [],
    communityIds: [],
    platform: ["web", "app"],
    publishToNewUser: false,
    publishDay: 1,
    publishTime: null,
    start: undefined,
    end: undefined,
  };

  regionTree: any = [];

  get sections() {
    if (!this.article?.content) return [];

    return this.article.content
      .trim()
      .split("\n")
      .map((x) => {
        const line = x.trim();
        if (line.startsWith("<<") && line.endsWith(">>")) {
          return { sectionType: "subtitle", sectionContent: line.slice(2, line.length - 2) };
        } else {
          return { sectionType: "text", sectionContent: line };
        }
      });
  }

  constructor(store: ArticlesStore) {
    makeAutoObservable(this, {});
    this.store = store;
  }

  @action edit() {
    this.store.editStore.show(this.article, true);
  }

  @action updateArticle(article) {
    this.article = { ...this.article, ...article };
  }

  @action show(id) {
    this.id = id;
    this.publish = {
      type: "All",
      commentType: "None",
      articleId: id,
      publishDate: undefined,
      onlyNotReached: false,
      platform: ["web", "app"],
      regionIds: [],
      divisionIds: [],
      communityIds: [],
      publishToNewUser: false,
      publishDay: 1,
      publishTime: null,
      start: undefined,
      end: undefined,
    };

    this.showDlg = true;
    Api.content.article.article(id).then((res) => {
      runInAction(() => {
        this.article = res.data.article;
      });
    });
    Api.content.article.articlePublishRegions(id).then((res) => {
      runInAction(() => {
        this.regionTree = mapNodes(res.data.articlePublishRegions);
      });
    });
  }

  @action close() {
    this.showDlg = false;
  }

  @action save(values) {
    this.saving = true;
    let publishTime: string | undefined = undefined;
    if (values.type === "Individual" && values.publishToNewUser === false) {
      publishTime = moment(values.publishTime).format("HH:mm:ss");
    }
    let start: string | undefined = undefined;
    let end: string | undefined = undefined;
    if (values.start) {
      start = moment(values.start).format("YYYY-MM-DD");
    }
    if (values.end) {
      end = moment(values.start).format("YYYY-MM-DD");
    }
    Api.content.article
      .publish({ ...this.publish, ...values, publishTime, start, end })
      .then((res) => {
        notification.success({ message: "Success!" });
        this.showDlg = false;
        this.store.refresh();
      })
      .finally(() => (this.saving = false));
  }
}
